import { createContext, useContext } from "react";

/**
 * GTM telemetry `section` for order surfaces sharing the drawer components.
 * Defaults to the drawer; {@link OrderDetailsPage} overrides it via the provider
 * so identical interactions are attributed to the correct surface.
 */
const OrderTelemetrySectionContext = createContext<string>("orders_drawer");

export const OrderTelemetrySectionProvider = OrderTelemetrySectionContext.Provider;

export function useOrderTelemetrySection(): string {
  return useContext(OrderTelemetrySectionContext);
}
